'use es6';

import JourneyDateRangePicker from 'reporting-enablement/components/reportEditors/JourneyDateRangeEditor/JourneyDateRangePicker';
import { getJourneyDateRangeFromReport, isJourneyReport } from '../../utils/salesAnalyticsHelpers';
import { jsx as _jsx } from "react/jsx-runtime";
const JourneyDateRangeControl = ({
  updateContext,
  report,
  onSavedReportChange,
  filteredGates
}) => {
  return /*#__PURE__*/_jsx(JourneyDateRangePicker, {
    onChange: updatedReport => {
      if (onSavedReportChange) {
        onSavedReportChange(updatedReport);
      } else {
        updateContext({
          journeyDateRange: getJourneyDateRangeFromReport(updatedReport, filteredGates)
        }, report);
      }
    },
    report: report
  });
};
JourneyDateRangeControl.displayName = 'JourneyDateRangeControl';
JourneyDateRangeControl.isUsableForReport = ({
  report
}) => isJourneyReport(report);
export default JourneyDateRangeControl;